import { useState } from "react";
import PropTypes from "prop-types";
import { Checkbox, Icon } from "semantic-ui-react";
import { SuiModal } from "../../common/suiModal";

function ConsiderationMetricsModal({ isOpen, onClose, onPrimaryClick }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const modalContent = (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 16,
        paddingTop: 8,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: -8,
          left: -8,
          background: "#1E63E9",
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 0.5,
          padding: "4px 12px",
          borderRadius: 999,
        }}
      >
        Nuevo
      </div>

      <div
        style={{
          width: 88,
          height: 88,
          borderRadius: "50%",
          background: "#EEF2FF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-hidden="true"
      >
        <Icon name="chart line" size="big" style={{ margin: 0, color: "#1E63E9" }} />
      </div>

      <div
        style={{
          fontSize: 20,
          lineHeight: "26px",
          fontWeight: 700,
          color: "rgba(0,0,0,0.87)",
        }}
      >
        ¡Nuevas métricas de consideración disponibles!
      </div>

      <div
        style={{
          fontSize: 14,
          lineHeight: "20px",
          color: "rgba(0,0,0,0.75)",
        }}
      >
        Ahora puedes consultar Product Page View, Add To Cart y Abandonment Rate dentro del Reporte de Retail
        Attribution. Entiende cómo interactúan los usuarios con tus productos antes de la compra y utiliza estos datos
        para optimizar tus campañas. Descarga tu reporte ahora.
      </div>

      <Checkbox
        checked={dontShowAgain}
        onChange={(_, { checked }) => setDontShowAgain(Boolean(checked))}
        label="No volver a mostrar este mensaje"
        style={{ marginTop: 8 }}
      />
    </div>
  );

  const modalButtons = [
    {
      text: "Cerrar",
      onClick: () => onClose(dontShowAgain),
      props: {
        basic: true,
      },
    },
    {
      text: "Descargar reporte",
      color: "primary",
      onClick: () => onPrimaryClick(dontShowAgain),
    },
  ];

  return (
    <SuiModal
      isOpen={isOpen}
      onClose={() => onClose(dontShowAgain)}
      modalSize="tiny"
      hideCloseIcon={false}
      isScrollableModalBody
      isContentLoading={false}
      modalContent={modalContent}
      modalButtons={modalButtons}
    />
  );
}

ConsiderationMetricsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
};

export default ConsiderationMetricsModal;
